/* May Designs personalization helpers. Updated 2026-10-26.
   1. Masks the cover while Customily tears down the theme gallery and builds its canvas.
      2026-10-26: the mask no longer times out to a blank cover. It stays (showing the cover photo)
      until Customily has actually painted its canvas and either drawn the default plate or the
      customer has touched an option. Slow Customily loads (15 to 20s observed) used to hit the old
      12s failsafe and leave a blank white cover.
   2. Draws the Customily preview on load so the default plate is visible on arrival
      (retries until Customily has mounted its canvas; a one-shot nudge raced it and often missed).
      2026-10-26: retries for up to 60s instead of 15s, so slow loads still get the default plate.
   3. Blocks add-to-cart when personalization text is empty or still the placeholder.
   4. Blocks add-to-cart when "Personalize this product?" is No but personalization TEXT is still attached
      (order #28824: No variant shipped with a "Your Name" plate).
      2026-10-08: only typed text counts. Pattern, shape, font and color selections are ignored, because
      pattern pickers carry a checked Pattern radio on No and the old check blocked every No add-to-cart.
   5. (2026-10-13) No longer used. The theme does not pick options on the customer's behalf; Shape Color
      defaults belong in Customily's option sets.
   6. 2026-10-13: when Customily would block on an empty required option (e.g. Shape Color on a name),
      blocks first and shows the same warning box next to that option, scrolled into view. Customily's
      own signal is a faint "Required" label, so customers saw nothing happen. */
(function () {
  var PLACEHOLDERS = ['your name here','your text here','your monogram here','your phrase here','type here','enter name',
                      'your name','your text','your monogram','your phrase','your initials','your initial','your word'];
  var MESSAGE = 'Add your personalization text below, or switch "Personalize this product?" to No.';
  var NO_MESSAGE = 'This notebook is set to no personalization, but a name is still on the cover. Switch "Personalize this product?" to Yes to add your text, or reload the page to start fresh.';
  var BUTTONS = '[name="add"], .shopify-payment-button button, .shopify-payment-button__button';
  var PERSONALIZE = 'select[name="options[Personalize this product?]"]';
  var ACCENT = '#b3454f';
  var BOX_CSS = 'display:flex;align-items:flex-start;gap:8px;background:#fdecef;border:1px solid ' + ACCENT + ';border-left:4px solid ' + ACCENT + ';border-radius:4px;color:#7a2b33;padding:10px 12px;margin:10px 0;font-size:15px;line-height:1.35;font-weight:600;';
  var nudged = false;
  var userTouched = false;

  /* Real (trusted) interaction with the personalizer or the Personalize select. Used so the cover
     mask can step aside once the customer is working with a live preview, even if the default-plate
     nudge never succeeded. */
  ['input', 'change', 'click'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      if (!e.isTrusted || !e.target || !e.target.closest) return;
      if (e.target.closest('.customily_option, ' + PERSONALIZE)) userTouched = true;
    }, true);
  });

  function forms() {
    return Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"]'));
  }

  function textFields(form) {
    return Array.prototype.slice.call(
      form.querySelectorAll('textarea[name^="properties["], input[type="text"][name^="properties["]')
    ).filter(function (i) { return !!i.offsetParent; });
  }

  function personalizeNo(form) {
    var sel = form.querySelector(PERSONALIZE) || document.querySelector(PERSONALIZE);
    return !!sel && sel.value === 'No';
  }

  /* Typed personalization text still attached to the form, visible or hidden. Selections (pattern,
     shape, font, color) are not counted. Underscore properties are Customily internals and are ignored. */
  function attachedPersonalization(form) {
    return Array.prototype.slice.call(
      form.querySelectorAll('textarea[name^="properties["], input[type="text"][name^="properties["]')
    ).filter(function (i) {
      if (i.disabled || /^properties\[_/.test(i.name)) return false;
      return !!(i.value || '').trim();
    });
  }

  function mismatch(form) {
    return personalizeNo(form) && attachedPersonalization(form).length > 0;
  }

  function invalid(form) {
    if (mismatch(form)) return true;
    if (personalizeNo(form)) return false;
    var f = textFields(form);
    if (!f.length) return false;
    var allEmpty = true, hasPlaceholder = false;
    f.forEach(function (i) {
      var v = (i.value || '').trim().toLowerCase();
      if (v) allEmpty = false;
      if (PLACEHOLDERS.indexOf(v) > -1) hasPlaceholder = true;
    });
    return hasPlaceholder || allEmpty;
  }

  /* ---- 6. Customily required options ------------------------------------- */
  function optionName(opt) {
    var t = ((opt.innerText || '').split('\n')[0] || '').trim();
    return { required: t.indexOf('*') > -1, name: t.replace(/\*.*$/, '').trim() };
  }

  function missingRequired(form) {
    if (personalizeNo(form)) return null;
    var opts = Array.prototype.slice.call(document.querySelectorAll('.customily_option'));
    for (var k = 0; k < opts.length; k++) {
      var opt = opts[k];
      if (!opt.offsetParent) continue;
      var info = optionName(opt);
      if (!info.required || !info.name) continue;
      var radios = opt.querySelectorAll('input[type="radio"]');
      if (radios.length) {
        if (!Array.prototype.some.call(radios, function (r) { return r.checked; })) return { opt: opt, name: info.name };
        continue;
      }
      var sel = opt.querySelector('select');
      if (sel && !sel.value) return { opt: opt, name: info.name };
    }
    return null;
  }

  /* Smooth-scroll the warning into view; if the smooth scroll did not land (the theme sets
     scroll-behavior: smooth, which stalls in some browsers and background tabs), jump instead. */
  function reveal(el) {
    try { el.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (err) {}
    setTimeout(function () {
      var r = el.getBoundingClientRect();
      if (r.top >= 60 && r.bottom <= window.innerHeight * 0.8) return;
      var root = document.documentElement;
      var prev = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';
      window.scrollTo(0, Math.max(0, window.pageYOffset + r.top - window.innerHeight / 2));
      root.style.scrollBehavior = prev;
    }, 700);
  }

  function warnMissing(miss) {
    var old = document.querySelector('.personalization-warning');
    if (old && old.parentNode) old.parentNode.removeChild(old);
    var box = document.createElement('div');
    box.className = 'personalization-warning';
    box.setAttribute('role', 'alert');
    box.setAttribute('data-md-missing', '1');
    box.style.cssText = BOX_CSS;
    box.textContent = 'Pick a ' + miss.name + ' to continue.';
    miss.opt.parentNode.insertBefore(box, miss.opt);
    reveal(box);
  }

  function clearWarning(form) {
    var box = form.querySelector('.personalization-warning');
    if (box && box.parentNode) box.parentNode.removeChild(box);
    textFields(form).forEach(function (i) { i.style.boxShadow = ''; });
  }

  function revalidate() {
    forms().forEach(function (form) {
      var box = document.querySelector('.personalization-warning');
      if (!box) return;
      if (box.getAttribute('data-md-missing')) {
        if (!missingRequired(form) && box.parentNode) box.parentNode.removeChild(box);
        return;
      }
      if (!invalid(form)) clearWarning(form);
    });
  }

  function warn(form) {
    var isMismatch = mismatch(form);
    var field = isMismatch ? (form.querySelector(PERSONALIZE) || textFields(form)[0]) : textFields(form)[0];
    if (!field) return;
    var anchor = isMismatch ? (field.closest('.product-form__input, .selector-wrapper') || field.parentNode)
                            : (field.closest('.customily_option') || field.parentNode);
    var box = form.querySelector('.personalization-warning');
    if (box && (box.nextSibling !== anchor || box.getAttribute('data-md-missing'))) { box.parentNode.removeChild(box); box = null; }
    if (!box) {
      box = document.createElement('div');
      box.className = 'personalization-warning';
      box.setAttribute('role', 'alert');
      box.style.cssText = BOX_CSS;
      anchor.parentNode.insertBefore(box, anchor);
    }
    box.textContent = isMismatch ? NO_MESSAGE : MESSAGE;
    textFields(form).forEach(function (i) {
      var v = (i.value || '').trim().toLowerCase();
      i.style.boxShadow = (isMismatch || !v || PLACEHOLDERS.indexOf(v) > -1) ? '0 0 0 2px ' + ACCENT : '';
    });
    reveal(box);
  }

  function stop(e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
  }

  function block(e, form) {
    stop(e);
    warn(form);
  }

  /* Returns true if the add-to-cart was stopped. */
  function guard(e, form) {
    if (invalid(form)) { block(e, form); return true; }
    var miss = missingRequired(form);
    if (miss) { stop(e); warnMissing(miss); return true; }
    return false;
  }

  /* ---- 1. Cover mask ----------------------------------------------------
     The cover URL comes from Liquid (window.mdCoverSrc, set in layout/theme.liquid),
     because Customily can remove the theme gallery before this script runs. Falling
     back to the gallery image, skipping Customily's own control icons. */
  function coverSrc(media) {
    if (window.mdCoverSrc) return window.mdCoverSrc;
    var imgs = Array.prototype.slice.call(media.querySelectorAll('img'));
    for (var i = 0; i < imgs.length; i++) {
      var im = imgs[i];
      if (/(^|\s)cl-|customily/i.test(im.className || '')) continue;
      var s = im.getAttribute('data-src') || im.currentSrc || im.getAttribute('src') || '';
      if (!s || s.indexOf('data:') === 0) continue;
      return s;
    }
    return '';
  }

  function buildMask() {
    try {
      var media = document.querySelector('.product__media');
      if (!media) return false;
      if (media.querySelector('.md-cover-mask')) return true;
      var src = coverSrc(media);
      if (!src) return false;
      if (src.indexOf('//') === 0) src = window.location.protocol + src;
      if (getComputedStyle(media).position === 'static') media.style.position = 'relative';
      var mask = document.createElement('div');
      mask.className = 'md-cover-mask';
      mask.style.cssText = 'position:absolute;top:0;left:0;right:0;bottom:0;z-index:4;pointer-events:none;opacity:1;transition:opacity .4s ease;background-color:#fff;background-image:url("' + src + '");background-size:contain;background-position:center;background-repeat:no-repeat;';
      media.appendChild(mask);
      var started = Date.now();
      var fading = false;
      var watch = setInterval(function () {
        if (fading) return;
        if (!mask.parentNode) { media.appendChild(mask); }
        var wrap = document.querySelector('.canvas-wrapper');
        var canvasUp = wrap && wrap.getBoundingClientRect().width > 10;
        /* Reveal only once Customily has painted AND either the default plate was drawn, the customer
           is interacting, or 60s have passed with the canvas up. Never fade to a blank cover: if the
           canvas never paints, the cover photo simply stays. */
        var ready = canvasUp && (nudged || userTouched || Date.now() - started > 60000);
        if (!ready) return;
        fading = true;
        clearInterval(watch);
        /* let Customily finish drawing the text layer before revealing */
        setTimeout(function () {
          mask.style.opacity = '0';
          setTimeout(function () { if (mask.parentNode) mask.parentNode.removeChild(mask); }, 500);
        }, userTouched ? 0 : 700);
      }, 150);
      return true;
    } catch (err) { return true; }
  }

  /* ---- 2. Draw the default preview -------------------------------------- */
  /* Customily sometimes leaves its canvas container parked, hidden, directly under <body> and only
     mounts it after a real keystroke (synthetic input/change/keyup events do not do it). Its live
     preview handler hangs off the Vue component that owns the option sets, so call showCanvas()
     on it directly, and keep trying until the container is actually mounted and visible. */
  function previewMounted() {
    var c = document.querySelector('.cl-canvas-container');
    return !!c && c.parentElement !== document.body && c.getBoundingClientRect().width > 10;
  }

  function livePreview() {
    var els = document.querySelectorAll('.customily_option, .customily_option *');
    for (var i = 0; i < els.length; i++) {
      var vm = els[i].__vue__;
      for (var d = 0; vm && d < 6; d++, vm = vm.$parent) {
        if (vm.livePreviewHandler && typeof vm.livePreviewHandler.showCanvas === 'function') return vm.livePreviewHandler;
      }
    }
    return null;
  }

  function nudgePreview() {
    if (nudged) return true;
    if (previewMounted()) { nudged = true; return true; }
    if (!document.querySelector('canvas')) return false;
    var sel = document.querySelector(PERSONALIZE);
    if (sel && sel.value === 'No') return false;
    var fields = [];
    forms().forEach(function (form) { fields = fields.concat(textFields(form)); });
    if (!fields.some(function (i) { return (i.value || '').trim(); })) return false;
    try { var lp = livePreview(); if (lp) lp.showCanvas(); } catch (err) {}
    return false;
  }

  if (!buildMask()) {
    var maskTries = 0;
    var maskTimer = setInterval(function () {
      maskTries++;
      if (buildMask() || maskTries > 80) clearInterval(maskTimer);
    }, 50);
  }
  document.addEventListener('DOMContentLoaded', buildMask);

  var tries = 0;
  var timer = setInterval(function () {
    tries++;
    if (nudgePreview() || tries > 120) clearInterval(timer);
  }, 500);

  /* ---- 3 + 4 + 6. Guard --------------------------------------------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest && e.target.closest('form[action*="/cart/add"]');
    if (form) guard(e, form);
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest(BUTTONS);
    if (btn) {
      var form = btn.closest('form[action*="/cart/add"]');
      if (form && guard(e, form)) return;
    }
    setTimeout(revalidate, 300);
    setTimeout(revalidate, 1000);
  }, true);

  ['input', 'change', 'keyup'].forEach(function (evt) {
    document.addEventListener(evt, function () {
      setTimeout(revalidate, 50);
      setTimeout(revalidate, 600);
    }, true);
  });

  if (window.MutationObserver) {
    var mo = new MutationObserver(function () { revalidate(); });
    document.addEventListener('DOMContentLoaded', function () {
      forms().forEach(function (form) { mo.observe(form, { childList: true, subtree: true }); });
    });
  }
})();
